const locale = {
  SKILL_TRACKER_TEXT: 'Monitor de habilidades:',
  BACKLOG_LABEL_TEXT: 'Brechas',
  LEARNING_LABEL_TEXT: 'Objetivos de aprendizaje',
  COMPLETED_LABEL_TEXT: 'Adquirido',
};

export default locale;
